import React from 'react';
import PropTypes from 'prop-types';
import {useHistory, useLocation} from 'react-router-dom';

import {updateQuery, convertQuerySearch} from './utils';

function withQueryParams(mapping) {
  const propKeys = Object.keys(mapping);

  function mapQueryToProps(query) {
    return propKeys.reduce((result, propKey) => {
      const queryKey = mapping[propKey];
      result[propKey] = query[queryKey];

      return result;
    }, {});
  }

  function mapPropsToQuery(props) {
    return propKeys.reduce((result, propKey) => {
      const queryKey = mapping[propKey];
      result[queryKey] = props[propKey];

      return result;
    }, {});
  }

  function hoc(WrappedComp) {
    const WithQueryParams = (props) => {
      const history = useHistory();
      const location = useLocation();
      const localQuery = mapQueryToProps(convertQuerySearch(location.search));

      const replaceQuery = (query) => {
        const newQuery = mapPropsToQuery({
          ...localQuery,
          ...query,
        });
        updateQuery(history, {
          query: newQuery,
          push: false,
        });
      };

      const pushQuery = (query) => {
        const newQuery = mapPropsToQuery({
          ...localQuery,
          ...query,
        });
        updateQuery(history, {
          push: true,
          query: newQuery,
        });
      };

      const clearOwnQuery = (push = false) => {
        const updatedQuery = propKeys.reduce((result, propKey) => {
          const queryKey = mapping[propKey];
          result[queryKey] = undefined;

          return result;
        }, {});
        updateQuery(history, {
          push,
          query: updatedQuery,
        });
      };

      return (
        <WrappedComp
          {...props}
          query={localQuery} /* Mapped query params requested in "mapping" above */
          pushQuery={pushQuery}
          replaceQuery={replaceQuery}
          clearOwnQuery={clearOwnQuery}
        />
      );
    };

    WithQueryParams.propTypes = {
      query: PropTypes.object,
    };

    return WithQueryParams;
  }

  return hoc;
}

export default withQueryParams;
